<template>
  <div class="convos">
    <div class="w3-row-padding w3-margin-left">
      <div class="w3-col m12">
      <div class="w3-card w3-round w3-white">
        <div class="w3-container w3-padding">
          <h6 v-if="!isAuthenticated" style="text-align:center">
            <login-button v-bind:text="'Login to participate'" />
          </h6>
          <div v-else>
            <a @click="newConvo()" class="w3-bar-item w3-button w3-padding-large w3-hover-white" title="Start a Conversation" style="width:100%; align:center; display:block">
              <span>Start a Conversation </span>
              <font-awesome-icon :icon="['fal', 'comments']" />
              <font-awesome-icon :icon="['fal', 'plus']" style="position:relative; left:-4px;" />
            </a>
          </div>
        </div>
      </div>
      </div>
    </div>
    <br />

    <loading-indicator v-if="isLoading" v-bind:fullPage="false" />

    <div v-else>
      <div class="w3-container w3-card w3-white w3-round w3-margin-left w3-margin-bottom" :style="'border:5px solid ' + (convo.meta.isAllJybed?'#c0e0e8':'#f0ccdd')" v-for="(convo) in convos" :key="convo.id">
        <convo-view v-bind:convo="convo" />
      </div>
    </div>
  </div>
</template>

<script>
  import Convos from './Convos.ts'
  export default Convos
</script>
